module.exports = __webpack_public_path__ + "static/media/teacher-background.c0d29285.jpg";